import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ListPurchaseOperationRequestDto } from '@domain/purchase-operation/dtos/list-purchase-operation.request.dto';
import { PurchaseOperationResponseDto } from '@domain/purchase-operation/dtos/purchase-operation.response.dto';
import { SummaryPurchaseOperationRequestDto } from '@domain/purchase-operation/dtos/summary-purchase-operation.request.dto';
import { SummaryPurchaseOperationResponseDto } from '@domain/purchase-operation/dtos/summary-purchase-operation.response.dto';
import { RefId } from '@core/interface/ref-id.interface';
import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseOperationRequestDto } from '@domain/purchase-operation/dtos/export-purchase-operation.request.dto';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOperationService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('purchase/operation');
  }

  list(request: ListPurchaseOperationRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<PurchaseOperationResponseDto>>
    >(queryUrl, { params: { ...request } });
  }

  show(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/show/${request.refId}`;
    return this.http.get<ApiResponse<PurchaseOperationResponseDto>>(queryUrl);
  }

  export(request: ExportPurchaseOperationRequestDto) {
    const queryUrl = `${this.getApiUrl()}/export`;
    return this.http.post<ApiResponse<ExportListResponse>>(queryUrl, request);
  }

  summary(request: SummaryPurchaseOperationRequestDto) {
    const queryUrl = `${this.getApiUrl()}/summary`;
    return this.http.get<ApiResponse<SummaryPurchaseOperationResponseDto>>(
      queryUrl,
      { params: { ...request } },
    );
  }
}
